// @ts-check
import React, { useState } from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import Tab from '@liquidweb-dev/undercurrent/Tab';
import Tabs from '@liquidweb-dev/undercurrent/Tabs';
import DrawerSupportCall from 'components/standard/DrawerSupportCall';
import DialogCreateSupportCase from 'components/standard/DialogCreateSupportCase';
import PageLayout, {
	PageLayoutInsetContent,
} from 'components/standard/PageLayout';
import TabBar from 'components/standard/TabBar';
import useSupportPhoneNumbers from 'modules/queries/support/usePhoneNumbers';
import { Link as RouterLink } from 'react-router-dom';
import Button from '@liquidweb-dev/undercurrent/Button';
import SupportTier from 'components/standard/SupportTier';

/**
 * A layout for support pages.
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {'/support' | '/support/status' | '/support/mycases'} props.tabsValue
 * @param {boolean} [props.isLoading]
 */
const SupportLayout = ({ children, tabsValue, isLoading }) => {
	const {
		data: supportPhoneNumberData,
		isLoading: isSupportPhoneNumberLoading,
	} = useSupportPhoneNumbers({
		separate_toll_free: true,
	});

	const [isSupportCallOpen, setIsSupportCallOpen] = useState(false);
	const [isCreateCaseDialogOpen, setIsCreateCaseDialogOpen] = useState(false);

	const handleOpenCase = () => {
		setIsCreateCaseDialogOpen(true);
	};

	return (
		<PageLayout
			title="Support Center"
			actionsSlot={
				<Box sx={{ display: 'flex', gap: 100 }}>
					<Button
						onClick={handleOpenCase}
						sx={{ flex: { xs: 1, md: 'none' } }}
						size="large"
					>
						Create a support case
					</Button>
					{supportPhoneNumberData?.support && (
						<Button
							variant="secondary"
							onClick={() => setIsSupportCallOpen(true)}
							sx={{ flex: { xs: 1, md: 'none' } }}
							size="large"
						>
							Call us
						</Button>
					)}
				</Box>
			}
			isLoading={isLoading}
			note={
				!isSupportPhoneNumberLoading &&
				supportPhoneNumberData?.supportTier?.hasSupport && (
					<SupportTier tier={supportPhoneNumberData.supportTier.tier} />
				)
			}
			variant="dynamic"
		>
			<TabBar sx={{ marginBottom: 600 }} isLoading={isLoading}>
				<Tabs value={tabsValue} variant="scrollable">
					<Tab
						component={RouterLink}
						value="/support"
						to="/support"
						label="Common issues"
					/>
					<Tab
						component={RouterLink}
						value="/support/status"
						to="/support/status"
						label="Service status"
					/>
					<Tab
						component={RouterLink}
						value="/support/mycases"
						to="/support/mycases"
						label="My cases"
					/>
				</Tabs>
			</TabBar>
			<PageLayoutInsetContent sx={{ flexGrow: 1 }}>
				{children}
			</PageLayoutInsetContent>

			<DrawerSupportCall
				open={isSupportCallOpen}
				onClose={() => setIsSupportCallOpen(false)}
			/>
			<DialogCreateSupportCase
				open={isCreateCaseDialogOpen}
				onClose={() => setIsCreateCaseDialogOpen(false)}
			/>
		</PageLayout>
	);
};

export default SupportLayout;
